import { ReactNode } from "react";
import { AppHeader } from "./AppHeader";

interface PageLayoutProps {
  children: ReactNode;
  title?: string;
  showDrawerTrigger?: boolean;
  rightActions?: ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
  className?: string;
}

const maxWidthClasses = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  full: "",
};

export const PageLayout = ({
  children,
  title,
  showDrawerTrigger = true,
  rightActions,
  maxWidth = "full",
  className = "",
}: PageLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <AppHeader
        showDrawerTrigger={showDrawerTrigger}
        title={title}
        rightActions={rightActions}
      />
      <main 
        id="main-content"
        className={`container mx-auto px-6 pt-20 pb-8 ${maxWidthClasses[maxWidth]} ${className}`}
      >
        {children}
      </main>
    </div>
  );
};
